import React from 'react';
import { MenuItem, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import SalovareSelectField from './SalovareSelectField';
import { FIELD_PLACEHOLDER_COLOR } from './formFieldStyles';
import {
  IN_STORE_PAYMENT_METHODS,
  getStorePaymentMethodKey,
} from '../../constants/StorePaymentMethod';

const StorePaymentMethodField = ({
  value,
  onChange,
  error = false,
  helperText,
  disabled = false,
  required = false,
  label,
  excludeMethods = [],
}) => {
  const { t } = useTranslation();
  const methods = IN_STORE_PAYMENT_METHODS.filter((method) => (
    method === value || !excludeMethods.includes(method)
  ));

  return (
    <SalovareSelectField
      label={label ?? t('storePaymentMethods.label')}
      value={value}
      onChange={onChange}
      displayEmpty
      error={error}
      helperText={helperText}
      disabled={disabled}
      required={required}
      renderValue={(selected) => {
        if (!selected) {
          return (
            <Typography component="span" sx={{ color: FIELD_PLACEHOLDER_COLOR }}>
              {t('storePaymentMethods.placeholder')}
            </Typography>
          );
        }

        return t(`storePaymentMethods.${getStorePaymentMethodKey(selected)}`);
      }}
    >
      {methods.map((method) => (
        <MenuItem key={method} value={method}>
          {t(`storePaymentMethods.${getStorePaymentMethodKey(method)}`)}
        </MenuItem>
      ))}
    </SalovareSelectField>
  );
};

export default StorePaymentMethodField;
